// Firebase initialization
// NOTE: Security: For production avoid committing keys openly if repository is public.
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Simple validation to help during development
if (process.env.NODE_ENV !== 'test') {
  const missing = Object.entries(firebaseConfig)
    .filter(([,v]) => !v)
    .map(([k]) => k);
  if (missing.length) {
    // eslint-disable-next-line no-console
    console.warn('[Firebase] Variables manquantes:', missing.join(', '));
  }
}

const app = initializeApp(firebaseConfig);
let analytics = null;
try {
  if (typeof window !== 'undefined' && 'measurementId' in firebaseConfig && firebaseConfig.measurementId) {
    analytics = getAnalytics(app);
  }
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('Analytics non initialisé (environnement non supporté).');
}

export const db = getDatabase(app);
export { analytics };
export default app;
